import { Component, createRef } from 'react'
import Head from 'next/head'
import Page from '../layouts/main'
import styles from '../styles/modules/coaching.module.scss'

export default class Coaching extends Component {
  constructor(props) {
    super(props);
    this.state = {
      analytics: {}
    }
    this.page = createRef();
  }

  componentDidMount() {
    if (this.page.current) {
      this.setState({ ...this.state, analytics: this.page.current.analytics })
    }
  }

  render() {
    const { analytics } = this.state
    return (
      <Page id={styles['page-coaching']} ref={this.page}>
        <Head>
          <title>Coaching - Kudos Golf</title>
        </Head>

        <section className={`row section-content ${styles['section-coaching']}`}>
            <div className='col-lg-5 col-xl-6'>
              <h2 className={styles.heading}>Coaching</h2>
            </div>
        </section>
      </Page>
    )
  }
}
